import React, { useState, useRef } from "react"
import styled from "@emotion/styled"
import { chunk } from "lodash"
import parse from "html-react-parser"

import Edges from "../../Edges"
import { renderStars } from "./renderStars"
import ReviewsPagination from "./ReviewsPagination"

const ProductReviews = props => {
  const { itemsPerPage = 3, headline = "Reviews", reviews, product } = props

  const [filter] = useState(null)
  const [page, setPage] = useState(1)

  const containerRef = useRef(null)

  const filteredReviews = !filter
    ? reviews
    : reviews?.filter(item => item.score === parseInt(filter))
  const sortedReviews = filteredReviews
    .sort((firstItem, secondItem) => firstItem.score - secondItem.score)
    .reverse()
  const pages = sortedReviews && chunk(sortedReviews, itemsPerPage)

  const handleChange = (event, value) => {
    setPage(value)
  }

  return (
    <Container
      ref={containerRef}
      id="reviews"
      className="mb-[90px] px-[15px] xl:px-0"
    >
      <div className="mx-auto mb-[65px] max-w-[1250px] border-b-[2px] border-lightGrey"></div>

      <Edges size="md">
        {reviews && reviews?.length > 0 && headline && (
          <h2 className="text-darkBlue">{headline}</h2>
        )}
      </Edges>

      {pages &&
        filteredReviews &&
        filteredReviews?.length > 0 &&
        pages[page - 1] &&
        pages[page - 1].map((item, index) => {
          const { content, name, score, title } = item

          return (
            <div key={index}>
              <CustomerReview>
                <Edges size="md">
                  <CustomerInfo>
                    <div className="pt-[5px]">
                      <StarRating>{renderStars(score)}</StarRating>
                      <div className="pt-[15px] pb-[5px] text-subTitle2 font-semibold text-darkGrey">
                        {product?.title}
                      </div>
                      <h5 className="pb-[9px] pt-[5px] text-subTitle2 font-black uppercase text-darkGrey">
                        {title}
                      </h5>
                      <div className="mb-[10px] text-body2 capitalize">
                        {name}
                      </div>
                    </div>

                    {/* <div>{createdAt}</div> */}
                  </CustomerInfo>

                  <div className="mb-[7px]">{parse(content)}</div>
                </Edges>
              </CustomerReview>

              {index + 1 !== filteredReviews?.length && (
                <div className="mx-auto mb-[25px] max-w-[1250px] border-b-[2px] border-lightGrey"></div>
              )}
            </div>
          )
        })}
      {reviews && reviews?.length > 0 && pages && (
        <ReviewsPagination
          count={pages?.length}
          onChange={handleChange}
          page={page}
          pages={pages}
        />
      )}
    </Container>
  )
}

export default ProductReviews

const Container = styled.div`
  background: #fff;
`
const StarRating = styled.div`
  color: #fec600;
  display: flex;
  flex-direction: row;
`

const CustomerReview = styled.div`
  display: flex;
  padding: 15px 0;
  margin-bottom: 20px;
`
const CustomerInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
